import React, { useState, useEffect } from 'react';

const RegimenDropdownStep = ({ question, value, onAnswer, onNext, answers }) => {
  const [selectedRegimen, setSelectedRegimen] = useState(value || '');
  
  // Determine if patient is on Semaglutide or Tirzepatide based on their previous answers
  const getMedicationType = () => {
    const currentMedication = answers?.['current-glp-medications'];
    const recentDose = answers?.['recent-dose'];
    
    // Check recent dose answer for medication type
    if (recentDose) {
      if (recentDose.toLowerCase().includes('tirzepatide')) {
        return 'tirzepatide';
      }
      if (recentDose.toLowerCase().includes('semaglutide') || 
          recentDose.toLowerCase().includes('ozempic') || 
          recentDose.toLowerCase().includes('wegovy')) {
        return 'semaglutide';
      }
    }
    
    // Check current-glp-medications
    if (Array.isArray(currentMedication)) {
      if (currentMedication.includes('tirzepatide')) return 'tirzepatide';
      if (currentMedication.includes('semaglutide')) return 'semaglutide';
    }
    
    // Default to semaglutide if unknown
    return 'semaglutide';
  };

  const medicationType = getMedicationType();
  const options = medicationType === 'tirzepatide' 
    ? question.tirzepatideOptions 
    : question.semaglutideOptions;

  const handleSelect = (e) => {
    const val = e.target.value;
    setSelectedRegimen(val);
    onAnswer(val);
  };

  const handleContinue = () => {
    if (selectedRegimen) {
      onNext();
    }
  };

  return (
    <div data-testid={`step-${question.id}`}>
      {/* Question/Title */}
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-2">
        {question.question}
      </h2>

      {/* Subtitle */}
      {question.subtitle && (
        <p className="text-center text-gray-600 mb-4 px-4">
          {question.subtitle}
        </p>
      )}

      {/* Medication Type Label */}
      <div className="bg-gray-50 rounded-lg p-4 mb-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">
          {medicationType === 'tirzepatide' ? 'Tirzepatide' : 'Semaglutide'}:
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          {question.regimenType === 'alternative' && 'Alternative Regimen'}
          {question.regimenType === 'rapid' && 'Rapid Regimen'}
          {question.regimenType === 'twice-weekly' && 'Twice a Week Regimen'}
        </p>

        {/* Dropdown */}
        <select
          value={selectedRegimen}
          onChange={handleSelect}
          className="form-input w-full"
          data-testid="regimen-select"
        >
          <option value="">-- Select your regimen dose --</option>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {/* Note if present */}
      {question.note && (
        <p className="text-sm text-amber-700 bg-amber-50 p-3 rounded-lg mb-6">
          {question.note}
        </p>
      )}

      {/* Continue Button */}
      <button
        onClick={handleContinue}
        disabled={!selectedRegimen}
        className="btn-primary"
        data-testid="continue-button"
      >
        Continue
      </button>
    </div>
  );
};

export default RegimenDropdownStep;
